import { takeLatest } from 'redux-saga/effects';

import * as signInActions from 'store/modules/auth/signIn';
import { signInFieldChanged } from './utils';

export default function* listenSigInFieldChanged() {
  yield takeLatest(signInActions.setSignInFieldValue.toString(), signInFieldChanged);
}
